import moment from "moment/moment";
import {convertBookingDateFormat} from "../utilities";

export const userBookingsSelector = (bookings, userAuth) => {
    //console.log('[[userBookingsSelector]]', bookings);
    return bookings.filter((item) => {
        // let dateString = bookingDateFormat(dateValue);
        let testName = userAuth?.userName ? userAuth?.userName : userAuth?.Email;
        let courseAdminId = item?.data?.user?.roleId == 2 ? item?.data?.user?.userName : item?.data?.course?.data?.adminId;
        // console.log({ testName, item, courseAdminId });
        if (item?.data?.user?.roleId == 2 && userAuth?.roleId == 1) {
            testName = userAuth.SgsMemberId;
            courseAdminId = parseInt(item.data.memberId);
        }
        if (item?.data?.user?.roleId == 1 && userAuth?.roleId == 1) {
            testName = userAuth?.SgsMemberId;
            courseAdminId = parseInt(item?.data?.memberId);
        }
        const isDateAfterToday = date => {
            const now = moment().startOf("day").toDate();
            if (date >= now) {
                return true; //date is after today's date
            } else {
                return false;
            }
        };
        // console.log({ dateCheck: isDateAfterToday(moment(convertBookingDateFormat(item.data.date)).startOf("day").toDate()) });
        if (courseAdminId == testName && isDateAfterToday(moment(convertBookingDateFormat(item.data.date)).startOf("day").toDate()))
            return true;
    });
}
